import React from 'react';
import { useEffect, useState } from 'react';
import { useNavigate, Link } from "react-router-dom";
import $ from 'jquery';
import Modal from "react-modal";
import { withRouter } from '../../utils/withRouter';
import { axiosPost, axiosGet } from "../../react_axios/Axios"
import Loader from "../../utils/Loader";

const Steps = (number) => {
    // console.log(number.data)
    const bookingSteps = ['Organizer Info', 'Booking Details', 'Additional Services', 'Terms & Conditions', 'Summary', 'Cart', 'Payment']
    return (
        <>
            {
                bookingSteps.map((data, index) => (
                    <div class={index < number.data - 1 ? "md-step active done" : index > number.data - 1 ? "md-step" : "md-step active"}>
                        <div class="md-step-circle"><span>{index + 1}</span></div>
                        <div class="md-step-title">{data}</div>
                        <div class="md-step-bar-left"></div>
                        <div class="md-step-bar-right"></div>
                    </div>
                ))
            }
        </>
    )
}
export default Steps